import { Component, Inject, OnDestroy } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import { Subscription } from "rxjs";
import { PasskeyPromptService } from "src/app/Services/passkey-prompt.service";
import { PasskeyService } from "src/app/Services/passkey.service";

export interface PasskeySetupDialogData {
  email: string;
}

@Component({
  selector: "app-passkey-setup-dialog",
  templateUrl: "./passkey-setup-dialog.component.html",
  styleUrls: ["./passkey-setup-dialog.component.scss"],
})
export class PasskeySetupDialogComponent implements OnDestroy {
  registering = false;
  errorMessage = "";
  private dismissed = false;
  private backdropSub?: Subscription;

  constructor(
    private passkeyService: PasskeyService,
    private passkeyPromptService: PasskeyPromptService,
    private toastr: ToastrService,
    public dialogRef: MatDialogRef<PasskeySetupDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PasskeySetupDialogData
  ) {
    this.backdropSub = this.dialogRef.backdropClick().subscribe(() => {
      this.skip();
    });
  }

  ngOnDestroy(): void {
    this.backdropSub?.unsubscribe();
  }

  async createPasskey(): Promise<void> {
    if (this.registering) {
      return;
    }
    this.registering = true;
    this.errorMessage = "";
    try {
      await this.passkeyService.register("Passkey", "any");
      this.passkeyPromptService.clearSuppression(this.data?.email);
      this.toastr.success("Passkey created successfully");
      this.dismissed = true;
      this.dialogRef.close("created");
    } catch (error) {
      this.errorMessage = this.passkeyService.mapError(error);
      this.toastr.error(this.errorMessage);
    } finally {
      this.registering = false;
    }
  }

  skip(): void {
    if (this.dismissed) {
      return;
    }
    this.dismissed = true;
    this.passkeyPromptService.recordDismiss(this.data?.email);
    this.dialogRef.close("skipped");
  }
}
